import React, { useState, useEffect } from "react";
import { Card, CardBody, Table, Badge,Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import axios from "axios";
import { BASE_URL } from "../../global";
import "../../custom.css";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { getUserSetting } from "../../common/user-setting"
import { getMomentLocaleTimeFormat } from "../../common/utils/date-utils"

const TutorNotification = () => {
  const token = localStorage.getItem('authUser');
  let tutorKey = null;

  if (token) {
    try {
      const decoded = jwt_decode(token);
      tutorKey = decoded.pk_tut_key || decoded.tut_key;
    } catch (e) {
      tutorKey = null;
    }
  }

  const [notifications, setNotifications] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);

  const [selectedNotification, setSelectedNotification] = useState(null);

  const [markingRead, setMarkingRead] = useState(false);
  const userSetting = getUserSetting()

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        if (tutorKey) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          const res = await axios.get(
            `${BASE_URL}tutorNotification/notifications?tutorKey=${tutorKey}`
          );
          setNotifications(res.data.notifications || []);
        }
      } catch (error) {
        setNotifications([]);
      }
    };
    fetchNotifications();
  }, [tutorKey, token]);

  // Open modal and mark as read
  const handleRowClick = async (notification) => {

    setSelectedNotification(notification);

    setModalOpen(true);

    setMarkingRead(true);

    try {

      await axios.post(`${BASE_URL}tutorNotification/markAsRead`, {

        notificationId: notification.pk_t_notifi_id,

      }, {

        headers: { Authorization: `Bearer ${token}` }

      });

      // Update notifications array in state (immutably)

      setNotifications((prev) =>
        prev.map((n) =>
          n.pk_t_notifi_id === notification.pk_t_notifi_id
            ? { ...n, is_read: 1, read_on: moment().format("YYYY-MM-DD HH:mm:ss") }
            : n
        )
      );

      // Also update selected notification in modal, for instant UI update

      setSelectedNotification({
        ...notification,
        is_read: 1,
        read_on: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
    } catch (err) {
        console.log(err);
    }
    setMarkingRead(false);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedNotification(null);
  };
  return (
    <Card>
      <CardBody>
        <h4 className="mb-3">Tutor System Notifications</h4>
        <Table hover responsive>
          <thead>
          <tr>
            <th>#</th>
            <th>Type</th>
            <th>Message</th>
            <th>Status</th>
            <th>Created</th>
          </tr>
          </thead>
          <tbody>
          {notifications.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">No notifications</td>
            </tr>
          )}
          {notifications.map((n, idx) => (
            <tr
              key={n.pk_t_notifi_id}
              style={{ cursor: "pointer", background: n.is_read ? "#f8f9fa" : "#fff" }}
              onClick={() => handleRowClick(n)}
            >
              <td>{idx + 1}</td>
              <td>
                <Badge color="info">{n.types}</Badge>
              </td>
              <td style={{maxWidth:220, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}} title={n.ptext}>
                {n.ptext}
              </td>
              <td>
                {n.is_read ? <Badge color="success">Read</Badge> : <Badge color="warning">Unread</Badge>}
              </td>
              <td>{moment(n.created_on, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MM-YYYY")}{" "}{getMomentLocaleTimeFormat(n.created_on, "YYYY-MM-DDTHH:mm:ss.SSSZ", userSetting.locale)}</td>
            </tr>
          ))}
          </tbody>
        </Table>
        {/* Modal for notification details */}
        <Modal
          isOpen={modalOpen}
          toggle={closeModal}
          centered
          style={{ maxWidth: "70vw", width: "70vw" }}
          contentClassName="tutor-notif-modal-content"
        >
          <ModalHeader toggle={closeModal}>
            Notification Details

          </ModalHeader>
          <ModalBody >
            {selectedNotification ? (
              <>
                <div><strong>Type:</strong> {selectedNotification.types}</div>
                <div className="mt-2"><strong >Message:</strong><br />
                  <span className="p-4" style={{ whiteSpace: 'pre-wrap' }}>{selectedNotification.ptext}</span>
                </div>
                <div className="mt-2"><strong>Created On:</strong> {moment(selectedNotification.created_on).format("DD-MM-YYYY HH:mm")}</div>
                {selectedNotification.read_on &&
                  <div className="mt-2"><strong>Read On:</strong> {moment(selectedNotification.read_on).format("DD-MM-YYYY HH:mm")}</div>
                }
              </>
            ) : "No notification selected."}
            <div className="mt-3 text-end">
              <Button color="secondary" onClick={closeModal}>Close</Button>
            </div>
          </ModalBody>
        </Modal>

      </CardBody>
    </Card>
  );
};

export default TutorNotification;
